import { isAxiosError } from "axios";
import API from "serviceshift-ui/api-client";

import type { JobCost } from "@/typings/jobCost";
import { reportApiFailure } from "@/vuex/interceptors";

export default {
  // Resolves null on the flag-off response, a 404 with an empty body. Any
  // other 404 (unknown job, a route that isn't deployed) is a real failure.
  // Answered failures are reported to RUM here, because ignoreError skips the
  // interceptor's report; a 401 is left to the interceptor's redirect, and it
  // still reports no-response failures itself.
  async fetchJobCost(_: unknown, jobId: number): Promise<JobCost | null> {
    try {
      const response = await API.makeRequest<JobCost>(
        `/v2/jobs/${jobId}/job_cost`,
        { headers: { ignoreError: true } }
      );
      return response.data;
    } catch (error) {
      const response = isAxiosError(error) ? error.response : undefined;
      const status = response?.status;
      if (status === 404 && !response?.data) return null;
      if (status && status !== 401) reportApiFailure(error, "job_cost_load");
      throw error;
    }
  }
};
